import script from "./StockBasicTable.vue?vue&type=script&setup=true&lang=js"
export * from "./StockBasicTable.vue?vue&type=script&setup=true&lang=js"

import "./StockBasicTable.vue?vue&type=style&index=0&id=28931026&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28931026"]])

export default __exports__